import React, { useEffect, useState } from 'react';
import axiosClient from '../../axios-client';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { useStateContext } from '../context/ContextProvider';
import Footer from './footer/Footer';
import GestLayout from '../components/GestLayout';
import DefaultLayout from '../components/DefaultLayout';
import { Helmet } from 'react-helmet';

const DynamicContent = () => {
  const { token } = useStateContext()
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [pageExist, setPageExist] = useState(null);
  const [ loading, setLoading ] = useState();
  const [ metTitle, setMetaTitle ] = useState('');
  const [ metaDescription, setMetaDescription ] = useState('');
  const [ currentSlug, setCurrentSlug ] = useState('');

  useEffect(() => {
    fetchData(slug);
    appSettings();
  }, [ slug ]);

  const appSettings = () => {
    axiosClient.get('/app-settings')
      .then(({ data }) => {
          setMetaTitle(data.data.title)
          setMetaDescription(data.data.description);
        })
        .catch(() => {
            setLoading(false)
        })
  }

  const fetchData = async (currentSlug) => {
    setLoading(false)
    try {
      const response = await axiosClient.get(`/pages/${currentSlug}`);
      setCurrentSlug(currentSlug);
      setPageExist(response.data.success);
      setData(response.data.data.description);
      setLoading(true)
    } catch (error) {
      setLoading(false)
      setError(error);
      setLoading(true)
    }
  };

  if (!loading) {
    return <div className='text-center vh-85'>Loading...</div>;
  }

  return (
    <>
      <Helmet>
          <title>{currentSlug === 'terms-of-service' ? 'Terms and Conditions' : currentSlug === 'privacy-policy' ? 'Privacy Policy' : ''} | {metTitle}</title>
          <meta name="description" content={metaDescription}/>
          <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
      </Helmet>
      <div>
        {pageExist == true ? (
          <>
            {!token ? <GestLayout /> : <DefaultLayout />}
            <div className='container text-start py-4'>
              <div dangerouslySetInnerHTML={{ __html: data }}></div>
            </div>
          </>
        ) : (
          <>
            {token ? <GestLayout /> : <DefaultLayout />}
            <NotFound />
          </>
        )}

      </div>
      <Footer />
    </>
  );
};

export default DynamicContent;
